import React, { useContext, useEffect, useState } from 'react';
// Material UI
import { Link, Alert } from '@mui/material';
import { GoogleLoginButton } from '../UI/Buttons/GoogleButton';
import { useLocation, useNavigate } from 'react-router';
import axios from '../../axios';
import { SubscriptionContext } from '../../contexts/SubscriptionContext';
import { StreakContext } from '../../contexts/StreakContext';
import { FooterText, AuthContainer, LoginTitle } from './Login.styles';
import { Role } from './PriorityRules';
import { StyledRegisterButton } from '../UI/Buttons/StyledRegisterButton';
import EmailIcon from '@mui/icons-material/Email';

export default function LoginTeacher({ error, updateError, isStatusMessage, updateUserStatus }) {
	const location = useLocation();
	const isTeacherLogin = location.pathname === '/login/profesor';
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const { updateUser } = useContext(SubscriptionContext);
	const { setUserId } = useContext(StreakContext);
	const [googleError, setGoogleError] = useState(null);

	// Handle Google login success
	const handleGoogleLoginSuccess = async (code) => {
		setLoading(true);

		try {
			// Send the auth code to the backend
			const res = await axios.post('/api/login/oauth/google', {
				code: code,
				role: isTeacherLogin ? Role.Teacher : Role.Member
			});

			const loginResponse = res.data.message;
			const localStorageUser = {
				access: loginResponse.Access_Token,
				refresh: loginResponse.Refresh_Token,
				isAuthenticated: true,
				role: loginResponse.User.Role,
				userId: loginResponse.User.ID,
				firstName: loginResponse.User.FirstName,
				isFirstLogin: loginResponse.User.IsFirstLogin
			};

			updateUser(localStorageUser);
			setUserId(loginResponse.User.ID);

			localStorage.setItem('userData', JSON.stringify(localStorageUser));
			localStorage.setItem('user', JSON.stringify(loginResponse.User));

			axios.defaults.headers.common.Authorization = `Bearer ${loginResponse.Access_Token}`;

			setLoading(false);
			navigate('/');
		} catch (err) {
			setGoogleError('Autentificarea a eșuat. Te rugăm să încerci din nou.');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const authCode = queryParams.get('code');

		if (authCode) {
			handleGoogleLoginSuccess(authCode);
		}
	}, [location]); // Runs every time the URL changes

	useEffect(
		() => () => {
			updateUserStatus({ statusMessage: '', error: '' });
			updateError(null);
		},
		[updateUserStatus, updateError]
	);

	return (
		<AuthContainer>
			{!isStatusMessage && <LoginTitle variant="h4">Devino profesor!</LoginTitle>}

			{error && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{error}
				</Alert>
			)}
			{googleError && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{googleError}
				</Alert>
			)}
			<GoogleLoginButton
				loading={loading}
				isTeacherLogin={isTeacherLogin}
				text="Înregistrează-te cu Google"
			/>

			<StyledRegisterButton
				fullWidth
				onClick={() => navigate('/register/profesor')}
				startIcon={<EmailIcon />}
				disabled={loading}
			>
				Înregistrează-te cu email
			</StyledRegisterButton>

			<FooterText>
				Ai deja un cont?{' '}
				<Link
					component="button"
					underline="always"
					color="primary"
					onClick={() => {
						navigate('/login');
					}}
				>
					Autentifică-te
				</Link>
			</FooterText>
		</AuthContainer>
	);
}
